<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { ButtonV2, Container, InputV2, Modal } from '@Shelly/shelly-design-system';
	import { addIRDevice } from 'src/helpers/ir_controller_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	export let device: Device;
	export let showModal = false;

	let name = '';
	let waitForResponse = false;

	const handleClose = () => {
		showModal = false;
		name = '';
	};

	const handleSave = async () => {
		const trimmedName = name.trim();
		if (!trimmedName || waitForResponse) return;
		waitForResponse = true;
		const response: SettingRequest = await addIRDevice(device, trimmedName);
		onSettingsResponse(response, device, {
			success: $format('ir_controller_add_remote_success', {
				default: 'Remote created successfully.',
			}),
		});
		waitForResponse = false;
		if (response?.isok) handleClose();
	};
</script>

<Modal
	{showModal}
	title={$format('ir_controller_add_ir_device', { default: 'Add IR Device' })}
	on:close={handleClose}
	removeScrollPadding
>
	<Container slot="content" padding="scrollPaddings">
		<InputV2
			id="ir-controller-add-device-name"
			size="m"
			label={$format('ir_controller_device_name', { default: 'Device name' })}
			aria-label={$format('ir_controller_device_name', { default: 'Device name' })}
			info={$format('ir_controller_device_name_placeholder', {
				default: 'e.g. TV, AC, Receiver',
			})}
			icon={null}
			maxlength="255"
			bind:value={name}
		/>
	</Container>
	<div slot="footer" class="d-flex justify-content-end">
		<ButtonV2
			size="m"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			variant="secondary"
			on:click={handleClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</ButtonV2>
		<ButtonV2
			size="m"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			loading={waitForResponse}
			disabled={waitForResponse || !name.trim()}
			aria-label={$format('button_add', { default: 'Add' })}
			on:click={handleSave}
		>
			{$format('button_add', { default: 'Add' })}
		</ButtonV2>
	</div>
</Modal>
